import React, { useMemo } from 'react';
import { logos } from 'define/modalAside';
import LazyImage from 'components/UI/LazyImage';
import { useLang, useIsUSA } from 'utils/localisation';

import * as styles from './Logos.module.scss';

export default function Logos() {
  const lang = useLang();

  const isUSA = useIsUSA();

  const preparedLogos = useMemo(() => {
    if (lang === 'en' && isUSA) {
      return logos.us;
    }

    return logos[lang] ?? logos.en;
  }, [lang, logos, isUSA]);

  return (
    <div className={styles.logosWrapper}>
      {preparedLogos.map(({ src, alt }) => (
        <LazyImage key={alt} src={src} alt={alt} className={styles.logo} />
      ))}
    </div>
  );
}
